<template>
    <v-checkbox 
        :input-value="getValue"
        :label="label"
        @change="changeValue($event, item)"
        hide-details
        :id="id"
        class="pa-0 ma-0"
        :disabled="item.readonly === '1' ? true : false"
        :alvqa="alvqa"
    >
        <template v-slot:label>
            <div 
                style="margin-top:2px"
                :alvqa="alvqa + '-label'"
            >
                    {{label}}
            </div>
        </template>

    </v-checkbox>
</template>

<script>
export default {
    name: "SettingsCheckbox",
    props: {
        item: Object,
        label: String,
        id: String,
        alvqa: String
    },
    computed: {
        getValue() {
            if(this.item.readonly === '1') {
                this.changeValue(this.item.default, this.item)
                return this.item.default === '1' ? true : false
            }
            
            if(this.item.value === null) {
                return this.item.default === '1' ? true : false
            }
            else {
                return this.item.value === '1' ? true : false
            }
        }
    },
    methods: {
        changeValue(newValue, item) {
            newValue === true ? item.value = '1' : item.value = '0'
        },
    }
}
</script>

